import { Component, Input, OnInit } from '@angular/core';
import {
  ProgressColorMap,
  ProgressDisplayFormat,
  ProgressDisplayType,
} from './progress-bar.model';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sh-progress-bar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="wrapper">
      <progress
        *ngIf="type === ProgressDisplayType.Bar"
        [max]="total"
        [value]="value"
        [style.accent-color]="progressColor"
        [title]="title"
      ></progress>
      <span>{{ title }}</span>
    </div>
  `,
  styles: [
    `
      .wrapper {
        position: relative;
      }

      progress {
        display: flex;
        height: 3rem;
        margin: -0.5rem 0;
      }

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        color: black;
        display: block;
      }
    `,
  ],
})
export class ProgressBarComponent implements OnInit {
  @Input() total = 0;
  @Input() value = 0;
  @Input() format: ProgressDisplayFormat = ProgressDisplayFormat.Percentage;
  @Input() colorMap?: ProgressColorMap[];
  @Input() type: ProgressDisplayType = ProgressDisplayType.Bar;

  ProgressDisplayFormat = ProgressDisplayFormat;
  ProgressDisplayType = ProgressDisplayType;
  percentage = 0;

  ngOnInit() {
    this.setPercentage();
  }

  get progressColor(): string | undefined {
    if (!this.colorMap || this.value === 0) {
      return undefined;
    }

    // boundary is on the lower end, so we sort descending
    const sortedColorMap = [...this.colorMap].sort(
      (a, b) => (b.boundary ?? 0) - (a.boundary ?? 0)
    );
    for (const colorMapping of sortedColorMap) {
      if (this.percentage >= (colorMapping.boundary ?? 0)) {
        return colorMapping.color;
      }
    }

    return undefined;
  }

  private setPercentage() {
    const percentage = this.total > 0 ? (this.value / this.total) * 100 : 0;
    this.percentage = Math.round(percentage);
  }

  get title(): string {
    return this.format === ProgressDisplayFormat.Percentage
      ? `${this.percentage}%`
      : `${this.value} / ${this.total}`;
  }
}
